var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0.894531)",
    fill: "#DC272D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22852 10.0007H9.56185V11.334H8.22852V10.0007ZM8.22852 4.66732H9.56185V8.66732H8.22852V4.66732ZM8.88851 1.33398C5.20852 1.33398 2.22852 4.32065 2.22852 8.00065C2.22852 11.6807 5.20852 14.6673 8.88851 14.6673C12.5752 14.6673 15.5618 11.6807 15.5618 8.00065C15.5618 4.32065 12.5752 1.33398 8.88851 1.33398ZM8.89518 13.334C5.94852 13.334 3.56185 10.9473 3.56185 8.00065C3.56185 5.05398 5.94852 2.66732 8.89518 2.66732C11.8418 2.66732 14.2285 5.05398 14.2285 8.00065C14.2285 10.9473 11.8418 13.334 8.89518 13.334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityAlert);
export default __webpack_public_path__ + "static/media/SeverityAlert.fc895e95960a033f946f1f70309c2827.svg";
export { ForwardRef as ReactComponent };